import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2, RotateCcw } from "lucide-react";
import { api } from "../lib/api";

const fmt = (iso) => (iso ? new Date(`${iso.slice(0, 10)}T12:00:00`).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" }) : "—");

export default function CardVerify() {
  const { token } = useParams();
  const [res, setRes] = useState(null);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    setRes(null);
    api.get(`/courses/card/${token}/verify`).then(r => setRes(r.data)).catch(() => setRes({ valid: false, reason: "Vérification impossible" }));
  }, [token, tick]);

  if (!res) return <div className="max-w-md mx-auto px-6 py-24 text-center" data-testid="card-verify-loading"><Loader2 className="w-12 h-12 mx-auto animate-spin text-[color:var(--accent)]" /></div>;
  const ok = res.valid;
  return (
    <div className="max-w-md mx-auto px-6 py-14" data-testid="card-verify-page">
      <div className={`rounded-3xl p-8 text-center border-2 ${ok ? "border-green-400 bg-green-500/10" : "border-red-500 bg-red-500/10"}`} data-testid={`card-verify-${ok ? "valid" : "invalid"}`}>
        {ok ? <CheckCircle2 className="w-20 h-20 mx-auto text-green-400" /> : <XCircle className="w-20 h-20 mx-auto text-red-400" />}
        <h1 className={`font-display text-6xl mt-4 leading-none ${ok ? "text-green-300" : "text-red-300"}`}>{ok ? "Valide" : "Non valide"}</h1>
        {!ok && <p className="text-sm text-red-200 mt-2" data-testid="card-verify-reason">{res.reason}</p>}
        {res.attendance_marked && <p className="text-xs text-green-200 mt-2" data-testid="card-verify-attendance">Présence enregistrée pour la séance d'aujourd'hui.</p>}
        {res.first_name && (
          <div className="mt-6 space-y-1 text-left bg-black/30 rounded-2xl p-4 text-sm">
            <div className="font-display text-3xl leading-none" data-testid="card-verify-name">{res.first_name} {res.last_name}</div>
            <div style={{ color: res.color }}>{res.course_name} · {res.day_label} {res.slot?.start}–{res.slot?.end}</div>
            <div className="text-[color:var(--text-muted)]">{res.slot?.level}{res.slot?.age ? ` (${res.slot.age})` : ""} · {res.room}</div>
            <div className="text-[color:var(--text-muted)]">Formule {res.plan_label?.toLowerCase() || "—"} · {res.paid ? `payée, valable jusqu'au ${fmt(res.paid_until)}` : "non réglée"}</div>
            <div className="text-[color:var(--text-muted)]">Statut : {res.status} · N° {res.member_no}</div>
          </div>
        )}
        <div className="text-[10px] text-[color:var(--text-muted)] mt-4">Vérifié le {res.checked_at ? new Date(res.checked_at).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" }) : "—"}</div>
      </div>
      <div className="flex items-center justify-center gap-3 mt-6">
        <button type="button" onClick={() => setTick(t => t + 1)} data-testid="card-verify-refresh" className="inline-flex items-center gap-2 border border-[color:var(--border)] hover:border-[color:var(--accent)] px-5 py-2.5 rounded-full text-xs uppercase tracking-widest transition-colors"><RotateCcw className="w-3.5 h-3.5" /> Revérifier</button>
        <Link to="/admin" className="text-xs uppercase tracking-widest text-[color:var(--text-muted)] hover:text-white">Régie</Link>
      </div>
    </div>
  );
}
